const normalizeRouterBasePath = (basePath) => {
  const trimmedBasePath = basePath?.trim()

  if (!trimmedBasePath || trimmedBasePath === '/') return undefined

  const normalizedBasePath = trimmedBasePath.replace(/^\/+|\/+$/g, '')

  return normalizedBasePath ? `/${normalizedBasePath}` : undefined
}

const ROUTER_BASE_PATH = normalizeRouterBasePath(
  process.env.REACT_APP_ROUTER_BASE_PATH || process.env.PUBLIC_URL
)

const withRouterBasePath = (path, basePath = ROUTER_BASE_PATH) => {
  const normalizedPath = path?.startsWith('/') ? path : `/${path || ''}`

  return `${normalizeRouterBasePath(basePath) || ''}${normalizedPath}`
}

export { normalizeRouterBasePath, ROUTER_BASE_PATH, withRouterBasePath }
